import gtmPusher from '../../utils/gtmPusher';

const gaCustomizationAnalytics = (response) => {
  // -- Google Analytics --
  const pushObj = {
    event: 'addToCart',
    eventCategory: 'ecommerce',
    eventAction: 'add to cart',
    eventLabel: 'add on',
    eventValue: 0,
    eventNonInteraction: false,
    pageType: window.pageType,
    ecommerce: {
      currencyCode: window.config.default_currency,
      add: {
        actionField: {
          list: 'recommendation page: customizations',
        },
        products: [
          {
            id: '',
            name: 'customization',
            variant: response.data.data.map((tup) => tup[0]).join(','),
            category: 'add on',
            quantity: 1,
            dimension10: '',
            price: response.data.total_price,
          },
        ],
      },
    },
  };

  gtmPusher(pushObj);
  // -- End Google Analytics --
};

export default gaCustomizationAnalytics;
